/* * 本页面为通关单新增和通关单修改界面 * 通过pageType字段来区分：1新增，2修改 *
*/
<template>
  <div ref="pageView" class="page-view container-view">
    <!-- title -->
    <section class="title-section fixed-view">
      <e6-title>
        {{ pageTitle }}
        <template slot="breadcrumb">
          <e6-breadcrumb :breadcrumbs="breadcrumbs"></e6-breadcrumb>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- content -->
    <section
      class="content-section"
      :style="{ height: resizeViewHeight + 'px' }"
    >
      <div class="form-wrapper">
        <e6-form-extend
          class="e6-from--column-2"
          ref="formExtend"
          :formExtend="formExtend"
          :inline="true"
          label-width="200px"
          :submitLoadingState="loadingState"
          @submitForm="handleSubmitForm"
          @resetForm="handleResetForm"
        >
          <template slot-scope="slotForms">
            <el-form-item
              label="编号"
              prop="forms.cdNo"
              :rules="[
                {
                  required: true,
                  message: '请输入编号',
                  trigger: 'blur'
                },
                { validator: CheckComparyNameLength, trigger: 'blur' }
              ]"
            >
              <el-input
                v-model="slotForms.forms.cdNo"
                placeholder="编号"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="forms.cdType"
              label="类型"
              :rules="[
                { required: true, message: '请选择类型', trigger: 'change' }
              ]"
            >
              <dict-select
                v-model="slotForms.forms.cdType"
                placeholder="类型"
                :pkey="'customs_type'"
              ></dict-select>
            </el-form-item>
            <el-form-item
              prop="forms.attachment"
              label="附件:"
              ref="uploadAttachment"
              :rules="[
                { required: true, message: '请选择附件', trigger: 'change' }
              ]"
            >
              <el-upload
                class="el-upload-list__item-thumbnail"
                :class="{ hide: hideUpload }"
                action="/app/file/upload"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :on-success="handleAvatarSuccess"
                :on-change="handleChange"
                :beforeUpload="beforeAvatarUpload"
                :file-list="fileList"
                list-type="picture-card"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  只能上传jpg/png文件，且不超过2M
                </div>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible" :modal-append-to-body="false">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </el-form-item>

            <el-form-item
              prop="forms.bTime"
              label="时间"
              :rules="[
                { required: true, message: '请选择时间', trigger: 'blur' }
              ]"
            >
              <el-date-picker
                class="w230"
                v-model="slotForms.forms.bTime"
                type="date"
                size="mini"
                placeholder="选择时间"
                clearable
                value-format="timestamp"
              ></el-date-picker>
            </el-form-item>
            <br />
            <el-form-item class="remarkWidth"  prop="forms.remark" label="备注:"
            :rules="[{ validator: CheckRemarkLength, trigger: 'blur' }]"
            >
              <el-input
                type="textarea"
                :rows="3"
                v-model.number="slotForms.forms.remark"
                placeholder="备注"
              ></el-input>
            </el-form-item>
          </template>
          <template slot="submit">保存</template>
          <template slot="reset">返回</template>
        </e6-form-extend>
      </div>
    </section>
    <!-- content end -->
  </div>
</template>
``
<script>
import {
  FetchFindById,
  SaveCustomsDeclaration
} from '@/api/base/customsDeclaration'
import resizeListener from '_private/mixins/resizeListener'
import { CheckRemarkLength,CheckComparyNameLength } from '@/utils/validation'
// import { DeleteFile } from '@/api/public'

export default {
  mixins: [resizeListener],
  data() {
    return {
      breadcrumbs: [
        {
          path: '/home',
          isRedirect: true,
          meta: {
            title: '首页'
          }
        },
        {
          path: '/baseCustomsDeclarationList',
          isRedirect: true,
          meta: {
            title: '通关单信息'
          }
        }
      ],
      formExtend: {
        forms: {
          cdNo: '',
          cdType: '',
          bTime: '',
          attachment: '',
          remark: ''
        },
        extends: []
      },
      hideUpload: false,
      dialogImageUrl: '',
      dialogVisible: false,
      fileList: [],
      dicTypeKeyList: [],
      carrierList: [],
      warehouseIdList: [],
      editState: false,
      CheckRemarkLength: CheckRemarkLength,
      CheckComparyNameLength:CheckComparyNameLength,
      loadingState: false
    }
  },
  computed: {
    pageType() {
      return this.$route.query.pageType ? this.$route.query.pageType : '1'
    },
    pageTitle() {
      const pageTitle =
        this.pageType === '1' ? '通关单信息新增' : '通关单信息修改'
      return pageTitle
    },
    id() {
      return this.$route.query.id
    }
  },
  created() {
    let breadcrumb = {
      path: '/systemSettingDataDictionaryMaintenanceEdit',
      isRedirect: false,
      meta: {
        title: this.pageTitle
      }
    }
    this.breadcrumbs.push(breadcrumb)
    if (this.pageType !== '1') {
      this.FetchFindById({ id: this.id })
      this.editState = true
    }
  },
  methods: {
    handleRemove(file, fileList) {
      // DeleteFile({ fileName: this.formExtend.forms.attachment })
      this.formExtend.forms.attachment = ''
      this.hideUpload = fileList.length >= 1
    },
    handlePreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleAvatarSuccess(res) {
      this.formExtend.forms.attachment = res.result.filename;
      this.$refs['uploadAttachment'].clearValidate();
    },
    handleChange(file, fileList) {
      this.hideUpload = fileList.length >= 1
    },
     beforeAvatarUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'jpg'
      const extension2 = testmsg === 'png'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!extension && !extension2) {
        this.$message({
          message: '上传文件只能是 jpg、png格式!',
          type: 'warning'
        })
          return false;
      }
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 2MB!',
          type: 'warning'
        })
          return false;
      }
      return (extension&&isLt2M) || (extension2 && isLt2M)
    },
    // 修改通关单数据时，先获取通关单数据信息
    FetchFindById(response) {
      FetchFindById(response)
        .then(response => {
          this.formExtend.forms = Object.assign({}, response.result)
          this.fileList = [{ url: response.result.attachment }]
          this.hideUpload = this.fileList.length >= 1
        })
        .catch(error => {
          console.log(error)
        })
    },

    // 新增，修改通关单数据
    SaveCustomsDeclaration(response) {
      SaveCustomsDeclaration(response)
        .then(response => {
          this.submitCallback(response)
        })
        .catch(error => {
          console.log(error)
        })
    },
    // 新增通关单信息完成时的回调函数
    submitCallback(response) {
      let type = response.code === 1 ? 'success' : 'error'
      let message = response.message
      this.$message({
        showClose: true,
        message: message,
        type: type,
        duration: 2000,
        onClose: () => {
          if (type === 'success') {
            this.$router.push({
              path: '/baseCustomsDeclarationList',
              query: { refreshportion: true }
            })
          }
          this.loadingState = false
        }
      })
    },
    // 提交
    handleSubmitForm(e) {
      if (e) {
        this.loadingState = true
        this.SaveCustomsDeclaration(Object.assign({}, this.formExtend.forms))
      }
    },
    // 取消
    handleResetForm() {
      this.$router.push('/baseCustomsDeclarationList')
    }
  }
}
</script>

<style lang="scss" scoped>
.remarkWidth{
  width: 70%;
}
.upload-demo {
  width: 300px;
  margin: 10 150px 10px 200px;
}
.page-view {
  height: 100%;
}
.title-section {
  padding: 15px 20px 10px;
}
.content-section {
  overflow: auto;
}
.content-section {
  .form-wrapper {
    padding-top: 20px;
    margin: 0 20px;
    background-color: #fff;
  }
}
/deep/.hide .el-upload--picture-card {
  display: none;
}
/deep/ .e6-from--column-2 {
  .el-input {
    width: 300px;
  }
  .el-textarea {
    width: 500px;
  }
}
</style>
